import { MapPin, MessageSquare, User } from "lucide-react";
import { statusInfo, toneOf } from "@/lib/statuses";
import { fmtDay, fmtTime } from "@/lib/format";

export const Timeline = ({ events, admin = false }) => {
  if (!events?.length) return <p className="text-sm text-slate-500" data-testid="timeline-empty">Nessun evento registrato.</p>;
  return (
    <ol className="relative" data-testid="tracking-timeline">
      {events.map((e, i) => {
        const info = statusInfo(e.status);
        const tone = toneOf(e.status);
        const Icon = info.icon;
        const latest = i === 0;
        const last = i === events.length - 1;
        return (
          <li key={e.id} className="relative flex gap-4 sm:gap-6 pb-8 last:pb-0" data-testid={`timeline-event-${i}`}>
            <div className="hidden sm:block w-24 shrink-0 text-right pt-1.5">
              <div className="font-mono text-sm font-bold text-slate-900">{fmtDay(e.timestamp)}</div>
              <div className="font-mono text-xs text-slate-500">{fmtTime(e.timestamp)}</div>
            </div>
            <div className="relative flex flex-col items-center">
              <span className={`relative z-10 h-10 w-10 rounded-full flex items-center justify-center text-white ${tone.dot} ${latest ? "ring-4 ring-offset-2 ring-slate-200" : "opacity-90"}`}>
                <Icon className="h-5 w-5" />
              </span>
              {!last && <span className="absolute top-10 bottom-[-2rem] w-[2px] bg-slate-200" />}
            </div>
            <div className={`flex-1 min-w-0 pt-1 ${latest ? "" : "opacity-90"}`}>
              <div className="sm:hidden font-mono text-xs text-slate-500 mb-1">{fmtDay(e.timestamp)} – {fmtTime(e.timestamp)}</div>
              <div className="flex flex-wrap items-center gap-2">
                <h4 className={`font-bold ${latest ? "text-slate-900 text-base sm:text-lg" : "text-slate-800"}`}>{info.label}</h4>
                {latest && <span className="text-[10px] font-bold uppercase tracking-widest bg-[#E50914] text-white px-2 py-0.5">Ultimo</span>}
              </div>
              {e.location && (
                <p className="mt-1 flex items-center gap-1.5 text-sm text-slate-600"><MapPin className="h-3.5 w-3.5 text-[#E50914]" /> {e.location}</p>
              )}
              {e.description && e.description !== info.label && <p className="mt-1.5 text-sm text-slate-600">{e.description}</p>}
              {e.public_note && (
                <p className="mt-2 flex gap-2 text-sm bg-slate-50 border-l-2 border-slate-300 px-3 py-2 text-slate-700">
                  <MessageSquare className="h-4 w-4 mt-0.5 shrink-0 text-slate-400" /> {e.public_note}
                </p>
              )}
              {admin && e.created_by && (
                <p className="mt-1.5 flex items-center gap-1 text-xs text-slate-400"><User className="h-3 w-3" /> {e.created_by}</p>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
};
